function _extends() {
  _extends =
    Object.assign ||
    function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

import React, { useCallback, useMemo } from "react";
import { v4 as uuid } from "uuid";
import { Wrapper, StyledLabel, StyledInput, StyledBody } from "./Radio.style";

var Radio = _ref => {
  var { className, children, hasError, label, selectedValue, onValueSelect, ref } = _ref,
    props = _objectWithoutProperties(_ref, [
      "className",
      "children",
      "hasError",
      "label",
      "selectedValue",
      "onValueSelect",
      "ref"
    ]);

  var id = useMemo(() => uuid(), []);
  var { value, disabled } = props;
  var isChecked = selectedValue === value;
  var handleChange = useCallback(() => {
    if (!disabled && onValueSelect) {
      onValueSelect(value);
    }
  }, [disabled, value, onValueSelect]);
  return /*#__PURE__*/ React.createElement(
    Wrapper,
    {
      className: [className, isChecked && "checked", disabled && "disabled", hasError && "error"]
        .filter(Boolean)
        .join(" "),
      onClick: handleChange
    },
    /*#__PURE__*/ React.createElement(
      StyledInput,
      _extends(
        {
          hasChildren: !!children,
          checked: isChecked,
          id: id,
          type: "radio"
        },
        props
      )
    ),
    children,
    /*#__PURE__*/ React.createElement(
      StyledLabel,
      {
        htmlFor: id
      },
      typeof label === "string" ? /*#__PURE__*/ React.createElement(StyledBody, null, label) : label
    )
  );
};

export default Radio;
